<template>
  <div class="text-center">
    <v-dialog :fullscreen="$vuetify.breakpoint.mobile" v-model="dialog" width="600">
      <template v-slot:activator="{ on }">
        <v-btn class="text-right" color="success" small v-on="on" text>
          <v-icon left>add</v-icon>Thêm chuyên ngành
        </v-btn>
      </template>
      <v-card>
        <v-toolbar color="#FFB300" dense class="elevation-0" dark>
          <v-toolbar-title>Thêm Chuyên Ngành</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <major-form ref="majorForm"></major-form>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn depressed class="ma-2" color="primary" @click="save">
            <v-icon>add</v-icon>
            <span>Lưu</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import MajorForm from '@/components/basic/form/MajorForm'
import { mapActions } from 'vuex'

export default {
  components: {
    MajorForm,
  },
  props: {
    root: Object,
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    ...mapActions('major', ['createMajor']),
    cancel() {
      this.$refs.majorForm.reset()
      this.dialog = false
    },
    save() {
      const data = {
        ...this.$refs.majorForm.getData(),
        department: this.root.department.id,
        root: this.root.id,
      }
      this.createMajor({ data, options: {} })
      this.dialog = false
    },
  },
}
</script>
